import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import {
  ExploreState,
  changeExploreState,
  decodeExploreState,
  encodeExploreState,
} from "./exploreState";

/**
 * Explore's state, read from the address, and a function that changes it.
 *
 * Every change is a new entry of the browser's history, so the back button
 * steps through the states.
 */
export function useExploreState(): [
  ExploreState,
  (change: Partial<ExploreState>) => void,
] {
  const [searchParams, setSearchParams] = useSearchParams();

  const state = useMemo(
    () => decodeExploreState(searchParams),
    [searchParams],
  );

  const change = useCallback(
    (part: Partial<ExploreState>) => {
      setSearchParams((current) =>
        encodeExploreState(
          changeExploreState(decodeExploreState(current), part),
          current,
        ),
      );
    },
    [setSearchParams],
  );

  return [state, change];
}
